export const dev = {
   BASE_URL_DOMAIN: "https://dev-muisapi.givepls.com", // Common domain for all APIs
   BASE_URL : "https://edonation-versionupgrade3-api.givepls.com/api/eDonation", // DEV with AUTH
   BASE_URL_WAKAF: "https://edonation-dev-api.givepls.com/v8/api/eDonation", // DEV with AUTH - 
   OPENAI_BASE_URL : "https://api.openai.com/v1",
   // RECEIPT_URL : "https://oazaz035k5.execute-api.ap-southeast-1.amazonaws.com/Stage", // NOT USED in Dev - Maintained to avoid build failure 
   // BASE_URL_ENROLL: "https://s2uoehm5sd.execute-api.ap-southeast-1.amazonaws.com/Stage", // NOT USED in Dev - Maintained to avoid build failure 
   // BASE_URL_CONFIG: "https://s7ml87jpfe.execute-api.ap-southeast-1.amazonaws.com/Stage", // // NOT USED in Dev - Maintained to avoid build failure 
   // BASE_URL_OXPAY: "https://oazaz035k5.execute-api.ap-southeast-1.amazonaws.com/Stage", //// NOT USED in Dev - Maintained to avoid build failure 
   NGS_SINGPASS_URL : "https://staging.givepls.com/", //  singpass url for QR code generation //DEV - https://staging.givepls.com //UAT, PROD - https://app.givepls.com
   BASE_URL_POSTALCODE : "https://dev-muiscrmapi.givepls.com", //postal code api base url
   PAYNOW_QR_URL : "", // Paynow only available on UAT and PROD
   BASE_S3_URL:  'https://dva87thu93fa8.cloudfront.net/queue-buster/', // local: images/ |   
    BASE_URL_AICHATBOT: 'https://dev-chatbot-api.givepls.com',
   NGS_SINGPASS_ENV : 'DEV', // DEV, UAT, PROD
   CLIENT_PARAM : 'muis',
   SINGPASS_PLATFORM : 'web',
   SINGPASS_SEPERATOR : '_',
   
   SINGPASS_APPS : {
     MYINFO : 'myinfo',
     SGVERIFY : 'sgverify'
   },

  INSURANCE_TYPE: {
   CONVENTIONAL: 1,
   TAKAFUL: 2
  },
  
  SAFARI_FORMAT: {
     DATE: 'D MMM YYYY',
     TIME: 'h:mm A',
  },

   //Input field maxlength
   INPUT_MAXLENGTH: 25,

   ENROL_MAXLENGTH: {
      UNIT_NO: 5,
      BLOCK: 25,
      BUILDING_NAME: 25
   },

//   SECRET_KEY: "MUIS_SECRET_KEY",
  SESSION_TIME: {
     NEW: 10,
     EXTENDED: 10
  },

  RECALL_DELAY: 30000,

  OXPAY_RESPONSE : {
     FAILED : 'failed',
     SUCCESS : 'succeeded',
     PENDING : 'pending',
     INITIATED : 'initiated',
  },

  PAYMENT_METHOD: {
     PAYNOW: 'PayNow',
     DEBITCARD: 'DebitCard'
  },

  PAYMENT_MODE: {
   CONTACTLESS: 1,
   CASH: 6,
   CHEQUE: 7,
   GOOGLE_PAY: 2,
   APPLE_PAY: 3,
   NETS: 9,
   BANK_TRANSFER: 12,
},

  REGEX : {
     TITLECASE : /\b(\w)/g,
     NRIC: /^[STFGM]\d{7}[A-Z]$/,
     UEN: /^[A-Za-z0-9]*$/,
     UEN1: /((S|T|[0-9])([a-zA-Z0-9]{8,9})|([0-3])(\d{8})([A-Z]))/g,
     COMPANY_NAME: /^[a-zA-Z0-9\-&.\s]*$/,
     CONTACT_PERSON: /^[a-zA-Z\s]*$/,
     CONTACT_PERSON_WITH_SLASH: /^[a-zA-Z\s/]*$/,
     EMAIL_ADDRESS: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
     PASSWORD: /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[^0-9a-zA-Z]){1,})(?!.*\s).{7,}$/,
     UNIT_NUMBER: /\d+[A-Za-z]*-/,
     HTML: /<\/?[a-z][\s\S]*>/i,
     MULTIPLE_SPACES: /\s\s+/g,
     ALLOWED_CHARACTERS: /^[aA-zZ\s,&]+$/,
     ALLOWED_CHARACTERS_WITH_SLASH: /^[aA-zZ\s/,&]+$/,
     REMOVE_COMPANY_NAME_EXTRA_SPACES: /^[a-zA-Z0-9\-&.\s]*$/,
     INSURANCE_NAME_REGEX: /^[a-zA-Z0-9\s.,'-]+$/,
     VALIDATION_REGEX: /^(\d{0,9})(\.\d{0,2})?$/,
     VALIDATE_DATE_FORMAT: /^(\d{4}\/\d{2}\/\d{2})$/,
     WAKAF_DATE_REGEX: /^([0-9]{2})-([0-9]{2})-([0-9]{4})$/
  },

  FLOW : {
     MANUALLY : 'Manually',
     SINGPASS : 'Singpass',
     ANONYMOUS : 'Anonymous',
     WAKAF: 'wakaf',
  },
  DATE_FORMAT : {
     NEXT_ZAKAT: 'DD MMM YYYY',
     END_DATE: 'DD-MM-YYYY',
     END_DATE_SUMMARY: "DD MMM, YYYY",
      CERTIFICATE_DATE_FORMAT: "M/D/YYYY h:mm:ss A",
      DAY_MONTH_YEAR: "D MMMM YYYY"
  },

  ROUTES: {
      WAKAF: "wakaf",
      PLEDGE: "pledging",
      ILMU: "ilmu",
      WMS: "wms",
   },

  CARD_TYPES: {
     VISA: 'VISA',
     MASTERCARD: 'Mastercard',
     AMEX: 'Amex',
     AMERICANEXPRESS: 'AMERICANEXPRESS',
     ECMC: 'ECMC'
  },

  DEFAULT_ORDER: 1,
  DONATION_AMOUNT: 1000000000000000,
  DEFAULT_CARD_NAME: 'Card Holder Name',

  PAYMENT_TYPES: {
     CARD_PAYMENT: 1,
     GOOGLE_PAY: 2,
     APPLE_PAY: 3
  },

  LOGIN_DETAILS: {
   GOOGLE_CLIENT_ID: "431838566550-su7u1tfn7s35t4pib702pme7od3e5cbl.apps.googleusercontent.com",
   FACEBOOK_APP_ID: "761477355018270"
  },

  COUNTRY_CODE: {
    SINGAPORE : 'SG'
  },

  RATES: {
   RATE_ON_TOTAL: 0.025
  },

   PAYMENT_STATUS: {
      ACCEPTED: 'Accepted',
      COMPLETED: 'Completed',
      REFUNDED: 'Refunded',
      VOIDED: 'Voided',
      AMOUNT_ACCEPTED: 'amt accepted',
      AMOUNT_COMPLETED: 'amt accepted',
      AMOUNT_REFUNDED: 'amt refunded',
      AMOUNT_VOIDED: 'amt voided',
   },

  //--------------------AUTH0 DETAILS ----------------------
  CONNECTION_TYPE: "Username-Password-Authentication",


  // -------------------- MUIS DETAILS ----------------------- 
   ENROLL_MANULLY_ID : 1,
   ENROLL_CORPORATE_ID : 2,
   MUIS_CHARITY_ID : 16,
   MUIS_CHARITY_ID_ENROLL: 16,//As we have dependency on homepage API so adding separate constant for now
   //for charityId
   APPEAL_ID_DEFAULT : 0,
  
  //----------------- HOMEPAGE BLOCK IDS ------------------- 
  NEWS_LETTER_BLOCK_ID: 13,
  GALLARY_EXPLORE_BLOCK_ID: 14,
  CONTACT_US_BLOCK_ID: 15,
  SOCIAL_MEDIA_BLOCK_ID: 16,
  DONATION_BLOCK_ID: 5,
  ADOPT_ART_WORK_BLOCK_ID: 6,
  CORE_PRIVILEDGE_BLOCK_ID: 9,
  PATRON_HEADING_BLOCK_ID: 8,
  PATRON_PROGRAM_BLOCK_ID: 10,
  DONOR_WALL_BLOCK_ID: 12,
  ACHIEVEMENTS_BLOCK_ID: 7,
  DONATION_WIDGET__BLOCK_ID: 4,

  //--------------------------------------------------
  DONOR_WALL_DONOTE_NOW_SETTING_ID: 16,
  DONOR_WALL_SEE_WALL_SETTING_ID: 15,

  //------------------------------------------------------
  DONATION_MIN_AMOUNT: 0.01,
  WAKAF_DONATION_MIN_AMOUNT: 5,
  WAKAF_WMS_DONATION_MIN_AMOUNT: 10,
  DONATION_MAX_AMOUNT: 999999,
  WAKAF_DONATION_MAX_AMOUNT: 150000,
  WAKAF_ENROLL_MAX_AMOUNT: 20000,

  CONTACT_US: "#",
  SUPPORT: "#",
  SITE_MAP: "#",
  TERMS_OF_USE: "https://www.muis.gov.sg/Footer/Terms-of-Use",
  PRIVACY_POLICY: "https://www.muis.gov.sg/Footer/Privacy-Statement",
  TERMS_CONDITION: "#",

  //------------------------------------------------------
  TYPE: "DEV",

  AWS_COGNITO_LOGIN_POOL: {
   USER_POOL_ID: "ap-southeast-1_ojplXJFaO",
   CLIENT_ID: "4hrc72pkutfv9kr07foj22mhmr",   
  },

  // PAYMENT DONE THANK YOU VIDEO YOUTUBE URL
  PAYMENT_THANK_YOU_VIDEO: 'https://www.youtube.com/embed/Ln4VZEDGgc4?rel=1&modestbranding=0&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1&playlist=Ln4VZEDGgc4&loop=1',
  
   // GOOGLE POSTAL CODE SERVICE
   GOOGLE_POSTAL_CODE_BASE_URL:'https://maps.googleapis.com/maps', //URL to get postal code

   //PAYNOW TIMER CONSTANTS IN MILLISECONDS
   QR_EXPIRE_DURATION : 5 * 60 * 1000, // 5 mins
   CHK_STATUS_INTERVAL : 3000, //3 sec
   ENQUIRY_GRACE_PERIOD : 30 * 1000, // 30 sec
   
   //ZAKAT BUSINESS CALCULATOR - MAXIMUM AMOUNT LIMIT ON FIELD
   MAX_AMT_LENGTH : 14, // $9,999,999,999

   // AWS AMPLIFY OAUTH DOMAIN
   OAUTH_DOMAIN: 'dev-paymuis.auth.ap-southeast-1.amazoncognito.com',

   EXTERNAL_RECEIPT: {
      Zakat: 'https://dev-paymuis.givepls.com/',
      Wakaf: 'https://dev-wakaf.givepls.com/',
      Korban: 'https://dev-korban.givepls.com/',
      Ilham: 'https://dev-ilham.givepls.com/',
      Wasiat: "https://dev-wakaf.givepls.com/"
   },

   S3_FILE_UPLOAD_URL: "https://kso0oj7w9d.execute-api.ap-southeast-1.amazonaws.com/dev/-getsignedurl-v2",
   S3_ATTACHMENT_FOLDER: "fileupload/pledging",

   // AMILID FOR ZAKAT WEB AND TERMINAL TRANSACTIONS
   GP_ACCOUNT: 'GPAccount',

   KAFFARAH_MAX_QTY: 9999,
   KAFFARAH_MIN_AMT: 5,
}

export const config = dev;

export const validateForm = {
   firstName: "Enter Valid First Name",
   fullName: "Enter full name",
   onbehalfOf: "Enter valid on behalf of name",
   address: "Please enter registered address",
   validMobile: "Please enter the valid mobile number",
   minMobileLength: "Minimum 8 numbers",
   maxMobileLength: "Maxmium 16 numbers",
   validEmail: "Please enter valid email address",
   requiredEmail: "Enter email address",
   validNric: "Enter Valid NRIC/FIN",
   validCkAgree: "Please Agree to our terms and conditions",
   taxDeductableText: "All contributions are entitled to a 250% tax deduction",
   validAgreeCheck: "Do you wish to receive information and updates on your Zakat contribution?",
   payMethod: "Please select any one option",
   nricExists: "Please Enter NRIC/FIN",
   dateOfBirth: "Please select date of birth",
   mobileNumberExists: "The mobile number already exists, please enter another mobile number",
}

export const appPreferenceId = {
   MUIS_HARTA: 13,
   MUIS_FITRAH: 14
}
// Total Amount
export const MAX_OXPAY_ACCEPTANCE_AMOUNT = 999999;
export const PLEDGE_ACCEPTANCE_AMOUNT = 999999999.99;
export const GOOGLE_API_KEY_AUTOCOMPLETE='AIzaSyAtwvfTxowI9lOT0f1-q7j3xQIjK79KWTA';

export const CARDINAL_COMMERCE = {
   GENERATE_SESSION_ID: "https://centinelapistag.cardinalcommerce.com/V1/Cruise/Collect",
   GENERATE_CHALLENGE_URL: "https://centinelapistag.cardinalcommerce.com/V2/Cruise/StepUp",
};

export const minimumAmount = 0.01;
export const SESSION_EXPIRE_DURATION = 30 * 60 * 1000// 30MINS IN MILLISECONDS

export const sessionTimeUnit = {
   time: 30, 
   unit: "minutes"
};

export const APP_FLOW = {
   FIDYAH: "FIDYAH",
   ZAKAT: "ZAKAT",
   KAFFARAH: "KAFFARAH",
   ILMU: "ILMU",
   WMS: "WMS",
   PLEDGE: "PLEDGE"
}

export const TIME_ZONE = {
   SINGAPORE : "SGT",
   GREENWICH : "GMT",
}

export const paths = {
   StripeSecret: '/enc/common/STRIPE_PK',
   SessionKey: '/enc/muis/SECRET_KEY',
   // ReceiptKey: '/enc/muis/RCPTKEY',
   // It is used for Cognito login purpose
   CognitoLoginAccessKey: '/enc/muis/COGNITO_LOGIN_ACCESS_KEY',
   CognitoLoginClientId: '/enc/muis/COGNITO_LOGIN_CLIENT_ID',
   //It is used for API Authentication
   AuthorizerAccessKey: '/enc/common/AWS_USER_POOL_ID',
   AuthorizerClientId: '/enc/common/AWS_CLIENT_ID'
}

export const charityConfig = [
   {
     url: 'https://dev-wakaf.givepls.com/wakaf-ilmu',
     charityId: 75,
     donationTypeId: 33,
   },
   {
     url: 'https://dev-wakaf.givepls.com/wms',
     charityId: 76,
     donationTypeId: 34,
   },
   {
      url: 'https://dev-wakafpledging.givepls.com',
      charityId: 75,
      donationTypeId: 33,
   }
]

export const DATE_FORMAT_REGEX = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/
export const REACT_APP_CRYPTO_JS_PASSWORD = 'QXBTdDI4NjIy';
export const REDUX_ENCRYPTION_KEY = "€Koj;yu(Rok5)S&";
export const CRYPTO_ACCESS_KEY = "ptjXV9hR%EC&a!QK";
export const AWS_SECRET_ACCESS_KEY = "U2FsdGVkX19AwevyA9y/IqI1JK1ubYIAT5Rz8/dtqEKhxfIEQcRbpwl9a+UO1xExwe/I1HbLOUbE9QvKq1kL3Q=="; 
export const AWS_SECRET_KEY_ID = "U2FsdGVkX18w+7X/nbglfNjFfKDQ8B0J09ChPfpujuKGwljaq6e3BjmLtAOEE2Gm";
export const AWS_REGION = "ap-southeast-1"

export const ZAKAT_SG = "https://zakat.sg/";
export const FIDYAH_SG = "https://fidyah.zakat.sg/";
export const SEARCH_POSTAL_CODE = "https://www.onemap.gov.sg/api/common"
export const API_KEY = "U2FsdGVkX1+6dGtMHEs46w75DKyEO3kbYWk1i1f7BwPbkEPjGG1bj0hl4xXAkTKuXHFHenmU3cskUAVbAnHjXID8s7WOB3hGWLkGkUAKOTlu4x4lmgyeC1145Hdwj0Jp0FW10PfzwD4+CevJUNeJNpLdZQ8by8iTGnY1MA04x/9kPvllonktcR/KZfipSPvK1RAhytqdzQKKJ0CmkdKeK1HYfHNbFiG4xgINgTLMCTTKlGB/bOqR6AbBnDKclhaX";